import Vue from 'vue';
import Vuex from 'vuex';
import { databasePlugin, vuexOrmPlugin } from '../plugins';
import modules from '@/store/modules/index.js';
import * as models from '@/models';

Vue.use(Vuex);

const axiosConfig = {
  baseURL: process.env.VUE_APP_BASE_URL
};

const ormPlugin = vuexOrmPlugin.register(axiosConfig);

Vue.use(databasePlugin, ormPlugin.database);

Object.keys(models).forEach((key) => {
  const modelModule = modules[key];

  if (modelModule) {
    delete modules[key];
  }

  ormPlugin.database.register(models[key], modelModule);
});

const plugins = [ormPlugin.plugin];

const store = new Vuex.Store({
  modules,
  plugins
});

export default store;
